import { API } from '../constants';
import { ProfileResponse } from '../types';

export const buildProfileFallback = (
  rawProfile: string | undefined
): Record<string, ProfileResponse | null> => {
  if (rawProfile === undefined) return {};

  try {
    return { [API.PROFILE]: JSON.parse(rawProfile) as ProfileResponse | null };
  } catch {
    return {};
  }
};
